// Initial state
function initialState() {
	return {
		CXFrame: {}
	}
}
const state = initialState()

// Getters
const getters = {
	listCXFrame: (state) => {
		return state.CXFrame
	},
	cxFrameType: (state) => {
		return state.CXFrame.SubCategory
	}
}

// Actions
const actions = {
	resetState ({ state, commit }) {
		commit('reset')
	},
	addCXFrame ({ state, commit }, frameDetails) {
		commit('setCXFrame', frameDetails)
	},
	removeCXFrame ({ state, commit }) {
		commit('setCXFrame', {})
	}
}

// Mutations
const mutations = {
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	setCXFrame (state, frameDetails) {
		state.CXFrame = frameDetails
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
